import { SearchConfig } from './types';

export function readConfigFromScriptTag(selector: string): SearchConfig | null {
  const el = document.querySelector(selector);

  if (!el?.textContent) {
    return null;
  }

  const decodedConfig = atob(el.textContent);

  return JSON.parse(decodedConfig) as SearchConfig;
}

export function readConfigFromJson(json: string): SearchConfig {
  return JSON.parse(json) as SearchConfig;
}
